
import type { RuntimeConfig } from './runtime-config.types'

// Get runtime configuration from global window object
export function getRuntimeConfig(): RuntimeConfig {
  if (typeof window === 'undefined') {
    //load in from process.env
    return process.env as unknown as RuntimeConfig

  }
  
  if (!window.__RUNTIME_CONFIG__) {
    throw new Error('Runtime config not loaded. Make sure runtime-config.js is included before the app.')
  }
  
  return window.__RUNTIME_CONFIG__
}

// Direct access to individual config values with type safety
export const runtimeConfig: RuntimeConfig = getRuntimeConfig()
